// Libraries
import React from 'react';

// Components
import DispatchDayDetails from './DispatchDayDetails';

const DispatchJobsView = ({date}: any) => <DispatchDayDetails date={date} />;

export default DispatchJobsView;
